/* src/Interviews/cards/UpcomingInterviewsCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';

import { PaperHeader, HeaderTable } from '../../../../app/components';

import { getUpcomingInterviews } from '../../selectors';
import { fetchApplicant } from '../../actions';
import styles from './styles';

class UpcomingInterviewsCard extends React.Component {
  constructor(props) {
    super(props);
    this._onRowClick = this._onRowClick.bind(this);
  }

  _onRowClick({ _id }) {
    const tutor = this.props.interviews[_id].tutor._id;
    this.props.fetchApplicant({ tutor });
  }

  render() {
    const { classes, upcoming } = this.props;
    return (
      <Paper className={classes.paper}>
        <PaperHeader text="Upcoming Interviews" />
        <HeaderTable data={upcoming} hover onRowClick={this._onRowClick} />
      </Paper>
    );
  }
}

UpcomingInterviewsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  upcoming: PropTypes.array.isRequired,
  fetchApplicant: PropTypes.func.isRequired,
  interviews: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  interviews: state.interviews.interviews.data,
  upcoming: getUpcomingInterviews(state),
});

const mapDispatchToProps = dispatch => ({
  fetchApplicant: params => dispatch(fetchApplicant(params)()),
});

export default compose(
  withStyles(styles, { name: 'UpcomingInterviewsCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(UpcomingInterviewsCard);



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/UpcomingInterviewsCard/index.js